// The query client's retry rule (main.tsx). A 4xx is the server's answer
// about the request itself — not found, no access, invalid — and asking
// again gets the same answer, so it shows at once instead of after a
// spinner through three retries. A network failure or a 5xx may pass, so
// those are retried, at most three times (TanStack's default count).

import { ApiError } from "./error";

const MAX_RETRIES = 3;

export function shouldRetry(failureCount: number, error: unknown): boolean {
    if (error instanceof ApiError && error.status < 500) return false;
    return failureCount < MAX_RETRIES;
}
